import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, Transition as _Transition, vModelCheckbox as _vModelCheckbox, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh sách nhập học", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body pt-5 umt-table umt-table-compact" }
const _hoisted_12 = { class: "filter-slim d-flex flex-column gap-3 mb-5" }
const _hoisted_13 = { class: "d-flex flex-wrap align-items-center gap-3" }
const _hoisted_14 = { class: "d-flex align-items-center position-relative" }
const _hoisted_15 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_16 = { style: {"width":"200px"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-primary fs-8 py-2 px-3 d-flex align-items-center text-nowrap",
  style: {"height":"32px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square me-1" }, null, -1)
const _hoisted_20 = { class: "ms-auto flex-grow-1 d-flex align-items-center justify-content-end gap-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope me-1" }, null, -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-icon btn-sm btn-secondary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" })
], -1)
const _hoisted_24 = {
  class: "menu menu-sub menu-sub-dropdown w-300px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-down fs-5 me-3 text-gray-500" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-down fs-5 me-3 text-success" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-down fs-5 me-3 text-primary" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tools fs-5 me-3 text-warning" }, null, -1)
const _hoisted_30 = {
  key: 1,
  class: "menu-item px-3 py-2 d-flex align-items-center text-gray-400 fw-semibold",
  title: "Tick chọn phiếu trước"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tools fs-5 me-3" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "d-flex align-items-center flex-wrap gap-2 fs-8"
}
const _hoisted_33 = {
  class: "badge badge-light-primary fs-8 py-2 px-3 text-nowrap",
  title: "Số ứng viên khớp bộ lọc hiện tại (KHÔNG tính hồ sơ đã hủy)"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill me-1" }, null, -1)
const _hoisted_35 = ["title", "onClick"]
const _hoisted_36 = {
  class: "text-muted text-nowrap ms-1",
  title: "Số ứng viên đã tiếp nhận hồ sơ / đã đóng phí giữ suất / đã đóng học phí"
}
const _hoisted_37 = { class: "text-gray-700" }
const _hoisted_38 = { class: "text-gray-700" }
const _hoisted_39 = { class: "text-gray-700" }
const _hoisted_40 = { class: "bg-light rounded p-4" }
const _hoisted_41 = { class: "nh-adv-grid" }
const _hoisted_42 = { class: "fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Đợt", -1)
const _hoisted_44 = { class: "fv-row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Học bổng", -1)
const _hoisted_46 = { class: "fv-row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Tiếp nhận hồ sơ", -1)
const _hoisted_48 = { class: "fv-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Thanh toán", -1)
const _hoisted_50 = { class: "fv-row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold fs-8 text-gray-600 mb-1 text-nowrap d-block" }, "Người phụ trách", -1)
const _hoisted_52 = { class: "d-flex justify-content-center" }
const _hoisted_53 = ["disabled", "value"]
const _hoisted_54 = { class: "text-start" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "text-primary fw-bold text-nowrap" }
const _hoisted_57 = { class: "text-muted fs-8 text-nowrap" }
const _hoisted_58 = { class: "d-flex flex-column" }
const _hoisted_59 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_60 = { class: "text-gray-800 text-hover-primary text-nowrap" }
const _hoisted_61 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_62 = { class: "d-flex flex-column align-items-start" }
const _hoisted_63 = ["title"]
const _hoisted_64 = {
  key: 0,
  class: "mt-1 text-nowrap"
}
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-success fs-9",
  title: "Hình thức xét"
}
const _hoisted_66 = {
  class: "badge badge-light-danger fs-9 ms-1",
  title: "Điểm xét tuyển"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = {
  key: 0,
  class: "bi bi-check-circle-fill text-success fs-5"
}
const _hoisted_71 = {
  key: 1,
  class: "bi bi-check-circle-fill text-gray-300 fs-5"
}
const _hoisted_72 = {
  key: 0,
  class: "bi bi-check-circle-fill text-success fs-5"
}
const _hoisted_73 = {
  key: 1,
  class: "bi bi-check-circle-fill text-gray-300 fs-5"
}
const _hoisted_74 = {
  key: 0,
  class: "bi bi-check-circle-fill text-success fs-5"
}
const _hoisted_75 = {
  key: 1,
  class: "bi bi-check-circle-fill text-gray-300 fs-5"
}
const _hoisted_76 = {
  class: /*#__PURE__*/_normalizeClass(`m-auto badge badge-light-primary`)
}
const _hoisted_77 = { class: "text-start" }
const _hoisted_78 = ["title"]
const _hoisted_79 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_80 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
  title: "Thao tác",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" })
], -1)
const _hoisted_83 = {
  class: "menu menu-sub menu-sub-dropdown w-275px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-lines-fill fs-5 me-3 text-info" }, null, -1)
const _hoisted_85 = {
  key: 0,
  class: "separator my-1"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer fs-5 me-3 text-primary" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-receipt fs-5 me-3 text-primary" }, null, -1)
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award fs-5 me-3 text-success" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5 me-3 text-info" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3 fs-5 me-3 text-danger" }, null, -1)
const _hoisted_97 = {
  key: 1,
  class: "d-flex flex-column align-items-center justify-content-center text-center py-15"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary mb-3" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, "Đang tải danh sách...", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-inbox text-gray-300 mb-2",
  style: {"font-size":"3rem"}
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold text-gray-700 mb-1" }, "Chưa có hồ sơ nhập học nào", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7" }, "Thử đổi bộ lọc hoặc từ khoá tìm kiếm.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ApplicantQuickDrawer = _resolveComponent("ApplicantQuickDrawer")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_9,
        _createTextVNode("Quay lại ")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-wrap align-items-center gap-3", _ctx.checkedCustomers.length != 0 ? 'd-none' : 'd-flex'])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  class: "form-control w-250px ps-11",
                  placeholder: "Tìm tên, MSSV, mã hồ sơ, CCCD...",
                  style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"}
                }, null, 512), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "popper-class": "filter-slim-dd",
                  style: {"width":"100%"},
                  placeholder: "— Tình trạng —",
                  modelValue: _ctx.formData.status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.status) = $event)),
                  multiple: "",
                  "collapse-tags": true,
                  onChange: _ctx.applyFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Hoàn tất",
                      value: "confirmed"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Chờ xác thực",
                      value: "completed"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Chưa hoàn tất",
                      value: "processing"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Đã hủy",
                      value: "cancel"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm umt-btn-32", _ctx.showAdvanced ? 'btn-primary' : 'btn-light-primary']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAdvanced = !_ctx.showAdvanced))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi me-1", _ctx.showAdvanced ? 'bi-funnel-fill' : 'bi-funnel'])
                }, null, 2),
                _createTextVNode(" Lọc nâng cao "),
                _createElementVNode("i", {
                  class: _normalizeClass(["bi ms-1 fs-8", _ctx.showAdvanced ? 'bi-chevron-up' : 'bi-chevron-down'])
                }, null, 2)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light umt-btn-32",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                title: "Đặt lại toàn bộ bộ lọc"
              }, [
                _hoisted_17,
                _createTextVNode("Đặt lại ")
              ])
            ], 2),
            (_ctx.checkedCustomers.length != 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode("Đã chọn " + _toDisplayString(_ctx.checkedCustomers.length) + " ", 1),
                  _createElementVNode("i", {
                    class: "bi bi-x-lg ms-2 cursor-pointer",
                    title: "Bỏ chọn tất cả",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkedCustomers = []))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.checkedCustomers.length != 0 && _ctx.canExport)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-info btn-sm umt-btn-32 text-nowrap",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendMailStudent()))
                  }, [
                    _hoisted_21,
                    _createTextVNode(" Gửi email hoàn tất nhập học (" + _toDisplayString(_ctx.checkedCustomers.length) + ") ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canExport || _ctx.canExportTCKT || _ctx.isSuperAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.canExport)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportFile && _ctx.exportFile(...args))),
                            class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                          }, [
                            _hoisted_25,
                            _createTextVNode("Xuất Excel ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.canExportTCKT)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.exportFileTCKT && _ctx.exportFileTCKT(...args))),
                            class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                          }, [
                            _hoisted_26,
                            _createTextVNode("Xuất Excel cho P.TCKT ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", {
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exportFileAdmin && _ctx.exportFileAdmin(...args))),
                              class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                            }, [
                              _hoisted_27,
                              _createTextVNode("Xuất chi tiết (kèm giá trị ưu đãi) ")
                            ]),
                            _hoisted_28,
                            (_ctx.checkedCustomers.length != 0)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.applicanttotalpaids())),
                                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                                }, [
                                  _hoisted_29,
                                  _createTextVNode("Fix Totalpaids (" + _toDisplayString(_ctx.checkedCustomers.length) + " đã chọn) ", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _hoisted_31,
                                  _createTextVNode("Fix Totalpaids (chưa chọn phiếu) ")
                                ]))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.checkedCustomers.length && _ctx.stats.rows)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _hoisted_34,
                  _createTextVNode(_toDisplayString(_ctx.stats.total) + " ứng viên ", 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.byStatus, (s) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: s.key,
                    class: _normalizeClass(["badge fs-8 py-2 px-3 text-nowrap cursor-pointer", [`badge-light-${s.state}`, _ctx.formData.status.length === 1 && _ctx.formData.status[0] === s.key ? 'border border-2 border-gray-700' : '']]),
                    title: _ctx.formData.status.length === 1 && _ctx.formData.status[0] === s.key ? 'Bấm để bỏ lọc' : `Bấm để chỉ xem hồ sơ ${s.label}`,
                    onClick: ($event: any) => (_ctx.toggleStatusChip(s.key))
                  }, _toDisplayString(s.n) + " " + _toDisplayString(s.label), 11, _hoisted_35))
                }), 128)),
                _createElementVNode("span", _hoisted_36, [
                  _createTextVNode(" Tiếp nhận hồ sơ "),
                  _createElementVNode("b", _hoisted_37, _toDisplayString(_ctx.stats.tnhs), 1),
                  _createTextVNode(" · Đóng phí giữ suất "),
                  _createElementVNode("b", _hoisted_38, _toDisplayString(_ctx.stats.pgs), 1),
                  _createTextVNode(" · Đóng học phí "),
                  _createElementVNode("b", _hoisted_39, _toDisplayString(_ctx.stats.hp), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "nh-adv-expand" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.phase,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.phase) = $event)),
                        onChange: _ctx.applyFilter
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhase, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item == '-1' ? 'Tất cả' : 'Đợt ' + item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        multiple: "",
                        "collapse-tags": true,
                        placeholder: "Tất cả",
                        modelValue: _ctx.formData.scholarship,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.scholarship) = $event)),
                        onChange: _ctx.applyFilter
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionScholarship, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.description,
                              value: item.code
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.isApproved,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.isApproved) = $event)),
                        onChange: _ctx.applyFilter
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: -1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã tiếp nhận",
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Chưa tiếp nhận",
                            value: 0
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        modelValue: _ctx.formData.paid,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.paid) = $event)),
                        onChange: _ctx.applyFilter
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Tất cả",
                            value: -1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã đóng phí",
                            value: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã đóng phí giữ suất",
                            value: 2
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "popper-class": "filter-slim-dd",
                        style: {"width":"100%"},
                        filterable: true,
                        modelValue: _ctx.formData.assignee,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.assignee) = $event)),
                        onChange: _ctx.applyFilter
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionAssignee, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: index
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.showAdvanced]
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.tableData.length!=0)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": true,
              classTable: "umt-list-th"
            }, _createSlots({
              "cell-checkbox": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-check form-check-sm form-check-custom form-check-solid", customer.status == 'completed' || customer.status == 'confirmed'?'':'disabled'])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input form-auto-check",
                      type: "checkbox",
                      disabled: !(customer.status == 'completed' || customer.status == 'confirmed'),
                      value: customer.id,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.checkedCustomers) = $event))
                    }, null, 8, _hoisted_53), [
                      [_vModelCheckbox, _ctx.checkedCustomers]
                    ])
                  ], 2)
                ])
              ]),
              "cell-lastModifiedBy": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_router_link, {
                    to: `/danhsachthutucnhaphoc/${customer.id}`,
                    class: "menu-link text-gray-800"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(customer.lastModifiedBy ? String(customer.lastModifiedBy).split("_")[0] : ""), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              "cell-code": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  class: "d-flex flex-column cursor-pointer",
                  title: "Xem nhanh hồ sơ xét tuyển",
                  onClick: ($event: any) => (_ctx.openQuickView(customer))
                }, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(customer.code || "—"), 1),
                  _createElementVNode("span", _hoisted_57, [
                    (customer.phase)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Đợt " + _toDisplayString(customer.phase), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (customer.infoMismatch)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass(["bi bi-exclamation-triangle-fill text-warning fs-8", { 'ms-1': customer.phase }]),
                          title: "Thông tin lệch giữa Nhập học / Ứng viên / Trúng tuyển — bấm để mở xem nhanh, so & đồng bộ"
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_55)
              ]),
              "cell-createdAt": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", null, _toDisplayString(customer.createdAtFormat), 1),
                      (customer.updatedAtFormat && customer.updatedAtFormat != customer.createdAtFormat)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Sửa: " + _toDisplayString(customer.updatedAtFormat), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-studentCode": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.studentCode), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-fullName": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "d-flex flex-column",
                  title: "Mở chi tiết phiếu nhập học"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_60, _toDisplayString(customer.fullName), 1),
                    (customer.studentCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, "MSSV: " + _toDisplayString(customer.studentCode), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-idNumber": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.idNumber), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-major": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("span", {
                        class: "text-nowrap",
                        title: customer.major
                      }, _toDisplayString(customer.major), 9, _hoisted_63),
                      (customer.adScore && customer.adScore.averageScore)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                            (customer.adScore.adForm)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(customer.adScore.adForm), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_66, _toDisplayString(customer.adScoreText), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-isApplicationFormPrinted": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "d-block text-center",
                  title: customer.isApplicationFormPrinted ? 'Đã tiếp nhận hồ sơ' : 'Chưa tiếp nhận hồ sơ'
                }, {
                  default: _withCtx(() => [
                    (customer.isApplicationFormPrinted)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_70))
                      : (_openBlock(), _createElementBlock("i", _hoisted_71))
                  ]),
                  _: 2
                }, 1032, ["to", "title"])
              ]),
              "cell-isTuition": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "d-block text-center",
                  title: customer.isTuition ? 'Đã đóng học phí' : 'Chưa đóng học phí'
                }, {
                  default: _withCtx(() => [
                    (customer.isTuition)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_72))
                      : (_openBlock(), _createElementBlock("i", _hoisted_73))
                  ]),
                  _: 2
                }, 1032, ["to", "title"])
              ]),
              "cell-isDeposit": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "d-block text-center",
                  title: customer.isDeposit ? 'Đã đóng phí giữ suất' : 'Chưa đóng phí giữ suất'
                }, {
                  default: _withCtx(() => [
                    (customer.isDeposit)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_74))
                      : (_openBlock(), _createElementBlock("i", _hoisted_75))
                  ]),
                  _: 2
                }, 1032, ["to", "title"])
              ]),
              "cell-status": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800 d-block text-end"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`ms-auto badge badge-light-${_ctx.statusTag[customer.status]?.state} fw-normal`)
                    }, _toDisplayString(_ctx.statusTag[customer.status]?.label), 3)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-paidBy": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachthutucnhaphoc/${customer.id}`,
                  class: "menu-link text-gray-800"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_76, _toDisplayString(customer.paidBy) + " ", 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-scholarshipName": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_77, [
                  (customer.freeTuitionRegistration && customer.freeTuitionRegistration.find(i => i.registrationType == 'scholarships'))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-gray-800 fs-6",
                        style: {"white-space":"normal","max-width":"220px","line-height":"1.3","text-align":"left","word-break":"break-word"},
                        title: customer.freeTuitionRegistration.find(i => i.registrationType == 'scholarships')?.scholarships?.name
                      }, _toDisplayString(customer.freeTuitionRegistration.find(i => i.registrationType == 'scholarships')?.scholarships?.name || 'Có học bổng'), 9, _hoisted_78))
                    : (_openBlock(), _createElementBlock("span", _hoisted_79, "—"))
                ])
              ]),
              "cell-goDetail": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_80, [
                  (customer.status == 'confirmed' || _ctx.isOnlySuperAdmin || (customer.studentId && _ctx.canViewCandidateDetail(customer.Student?.assignee, customer.Student?.groupAssignee)))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, [
                          (customer.studentId && _ctx.canViewCandidateDetail(customer.Student?.assignee, customer.Student?.groupAssignee))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/danhsachungvien/${customer.studentId}`,
                                class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_84,
                                  _createTextVNode("Chi tiết ứng viên (hồ sơ gốc) ")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (customer.studentCode && customer.status != 'cancel')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (customer.studentId && _ctx.canViewCandidateDetail(customer.Student?.assignee, customer.Student?.groupAssignee))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary",
                                  onClick: ($event: any) => (_ctx.printApplicantInfo(customer))
                                }, [
                                  _hoisted_87,
                                  _createTextVNode("In phiếu thông tin sinh viên ")
                                ], 8, _hoisted_86)
                              ], 64))
                            : _createCommentVNode("", true),
                          (['completed','confirmed'].includes(customer.status))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 2,
                                to: { path: `/danhsachthutucnhaphoc/${customer.id}`, hash: '#phieutiepnhan' },
                                class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_88,
                                  _createTextVNode("In phiếu tiếp nhận hồ sơ ")
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (customer.status == 'confirmed')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("div", {
                                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary",
                                  onClick: ($event: any) => (_ctx.printUuDai(customer))
                                }, [
                                  _hoisted_90,
                                  _createTextVNode("In phiếu xác nhận ưu đãi/học bổng ")
                                ], 8, _hoisted_89),
                                _hoisted_91,
                                _createElementVNode("div", {
                                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary",
                                  onClick: ($event: any) => (_ctx.sendMailStudent(customer.id))
                                }, [
                                  _hoisted_93,
                                  _createTextVNode("Gửi email hoàn tất nhập học ")
                                ], 8, _hoisted_92)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.isOnlySuperAdmin && customer.status != 'confirmed')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _hoisted_94,
                                _createElementVNode("div", {
                                  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-danger fw-semibold",
                                  onClick: ($event: any) => (_ctx.deleteApplicant(customer))
                                }, [
                                  _hoisted_96,
                                  _createTextVNode("Xóa phiếu nhập học ")
                                ], 8, _hoisted_95)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, [
              true
                ? {
                    name: "cell-assigneeName",
                    fn: _withCtx(({ row: customer }) => [
                      _createVNode(_component_router_link, {
                        to: `/danhsachthutucnhaphoc/${customer.id}`,
                        class: "menu-link text-gray-800 text-nowrap"
                      }, {
                        default: _withCtx(() => [
                          (customer.Student)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                (customer.Student.groupAssignee)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(customer.Student.Group?.groupName), 1))
                                  : (customer.Student.assignee)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(customer.Student.User?.fullName), 1))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["table-data", "total", "currentPage", "table-header", "rows-per-page"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_97, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_98,
                    _hoisted_99
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_100,
                    _hoisted_101,
                    _hoisted_102
                  ], 64))
            ]))
      ])
    ]),
    _createVNode(_component_ApplicantQuickDrawer, {
      ref: "applicantQuickDrawer",
      onSynced: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getData()))
    }, null, 512)
  ])), [
    [_directive_permission, [_ctx.Permission.APPLICANT_VIEW, _ctx.Permission.APPLICANT]]
  ])
}